module.exports = __webpack_public_path__ + "build/img/04.2c9ea579.jpg";